import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-personal-information-rounded-cell',
  templateUrl: './personal-information-rounded-cell.component.html',
  styleUrls: ['./personal-information-rounded-cell.component.scss'],
})
export class PersonalInformationRoundedCellComponent {
  @Input() label: string;
  @Input() value?: string;
  @Input() isLoading = false;
  @Input() withPlus = false;
  @Output() doPlusAction = new EventEmitter<void>();
}
